/* Native Shopify links and GET form own navigation; enhance disclosure/search only. */
(() => {
  const init = (root = document) => root.querySelectorAll('.moi-facets:not(.is-enhanced)').forEach(facets => {
    facets.classList.add('is-enhanced');
    const groups = [...facets.querySelectorAll('details')];
    const close = (except) => groups.forEach(group => { if (group !== except) group.open = false; });
    groups.forEach(group => group.addEventListener('toggle', () => { if (group.open) close(group); }));
    document.addEventListener('click', event => { if (!facets.contains(event.target)) close(); });
    facets.addEventListener('focusout', event => {
      if (event.relatedTarget && !facets.contains(event.relatedTarget)) close();
    });
    facets.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        const open = groups.find(group => group.open);
        if (open) { event.preventDefault(); close(); open.querySelector('summary').focus(); }
      }
    });
    facets.querySelectorAll('[data-facet-search]').forEach(search => search.addEventListener('input', () => {
      const panel = search.closest('.moi-facet-panel');
      const query = search.value.trim().toLocaleLowerCase();
      const options = [...panel.querySelectorAll('.moi-filter-option')];
      options.forEach(option => { option.hidden = !option.querySelector('.moi-filter-option-label').textContent.toLocaleLowerCase().includes(query); });
      panel.querySelector('.moi-facet-no-match').hidden = options.some(option => !option.hidden);
    }));

  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
